import { createSelector } from 'reselect';

const getShops = ({ exchange }) => exchange.shops;

const inputFuncs = [getShops];
const outputFunc = shops => [...Object.keys(shops)]
  .map(k => shops[k])
  .sort((a, b) => (a.id || 0) - (b.id || 0));

export default createSelector(inputFuncs, outputFunc);